import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 740px;
  min-width: 0;
  width: 100%;
  width: 90%;
  padding: 30px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  box-shadow: 0 12px 24px var(--color-shadow);
  border-radius: 8px;
  position: relative;
  max-height: 90vh;
  overflow: auto;
  color: var(--color-text);

  .head {
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    .search-icon {
      flex: 0 0 auto;
      color: var(--color-text-muted);
    }
    .input {
      flex: 1 1 auto;
      width: 100%;
      input {
        width: 100%;
        background: none;
        border: none;
        outline: none;
        box-shadow: none;
        color: var(--color-text);
      }

      input::placeholder {
        color: var(--color-text-muted);
      }
    }
    .clear-button {
      width: 50px;
      flex: 0 0 auto;
      background: none;
      border: none;
      padding: 0;
      color: var(--color-text-muted);
      font-size: 16px;
      font-weight: 500;
      line-height: 16px;
      :hover {
        color: var(--color-link);
      }
    }
    .close-button {
      width: 20px;
      flex: 0 0 auto;
      background: none;
      border: none;
      padding: 0;
      color: var(--color-text-muted);
      svg {
        width: 16px;
        height: 16px;
      }
      :hover {
        color: var(--color-link);
      }
    }
  }

  .head-divider {
    height: 1px;
    background: var(--color-border);
    margin-top: 5px;
    margin-bottom: 15px;
  }

  .tags {
    display: flex;
    flex-wrap: nowrap;
    gap: 5px;
    align-items: center;

    h4 {
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      color: var(--color-text-muted);
      margin: 0 5px 5px 0;
    }
  }

  .results {
    position: relative;
  }
`;
